import { Component, Prop, Host, h, State } from '@stencil/core';
import _ from 'lodash'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '../header-component/header-component';
import '../loader-component/loader-component'


/**
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/accordiondocuments-component.PNG)

#### Content Type
nypwebc_ct_DocumentsManuels

 */
@Component({
  tag: 'accordiondocuments-component',
  styleUrl: 'accordiondocuments-component.css',
  // shadow: true,
  scoped: true
})
export class AccordiondocumentsComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
 *Optional - To show/hide header. default is true
 */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;

  /**
 *Optional - To show see All link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All Url
 */
  @Prop() seeallurl: string;

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string = "See All";

  /**
    *Optional - number of items to retrieve
    */
  @Prop() count: number = 100;

  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"


  /**
  *Optional - expand all by default 
  */
  @Prop() expandall: boolean = false

/**
*Optional - Expand /collapse all toggle
*/@Prop() exptoggle: boolean = false

  /**
*Optional - is it SP Online site?
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";

  /**
   optional - option to sort differently. if its 2 then its alphabetical. otherwise by nypwebc_itemorder
    */
  @Prop() sortversion: number = 1;

  /**
   optional - to filter to only specific subsection. default is all 
    */
  @Prop() subsection: string = "all";


  @State() items: any = []
  @State() isLoading: boolean = true
  @State() expandallclick: boolean

  handleClick = () => {
    this.expandallclick = !this.expandallclick
  }

  componentDidLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;



    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }


    
    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }


    const filter = "nypwebc_Active eq 1";
    const config = {
      headers: { "Accept": "application/json; odata=verbose" }
    };
    // let sortexpr = "&orderby=ItemOrder"
    // if (this.sortversion === 2)
    // {
    //   sortexpr = "&orderby=nypwebc_Section"
    // }

    return fetch(siteUrl + "/_api/web/GetFolderByServerRelativeUrl('" + this.webpath + "/" + this.listname + "')?$expand=Files/ListItemAllFields&$top=" + this.count + "&$filter=" + filter, config)
      .then(response => response.json())
      .then(data => {
        // this.items = data.d.Files.results
        this.items = _.filter(data.d.Files.results, function (n: any) {
          return n.ListItemAllFields.nypwebc_Active === true;
        });
        this.isLoading = false
        this.expandallclick = this.expandall
      });

  }

  getContents = () => {
    const contentsArray = []

    const expToggleArray = []
    if (this.exptoggle) {
      expToggleArray.push(
        <a class="float-end" onClick={this.handleClick} style={{ paddingRight: "10px", paddingTop: "5px" }}  >
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABmJLR0QA/wD/AP+gvaeTAAABQ0lEQVRIie3Vv0oDQRAG8J8KmkaSdAqmsdEEH0PwHax8AiEvIIhWeQ8b64BFKh9AUEgTECtLFcFGg6DF7eHlXO9PSOkHA7dz38w37O7M8o8aWIr4trCaWb/ipUbONXwUETbxhQlGwc5qCHRxh0YRqYNxIPZqJBf4leI6GFYI2EFzHoGsSJroFnsR3gAHFXhgObd+w034nuAQFwUV9nAZeOPC8kuQHmYr4xugb76z+xMts9d9ILmmx9gP1ozEgZWKIu+59RRPWMd2sHs8V8y3eMQ6PsUujnK+K1zXFSnark/JNj1IOvhEMl5GmQJbfm/lXEgbrS858BTt4O8uSqAnab5Bwf8UpwpuWh75To6JxHhDyeQoRazCZkhYxq8kUmvYReLGZSKNOQTO/bw9E8l7tJElxPqk9GXLoR0sxRSPNeL/MYtvYfFDhGCJYBYAAAAASUVORK5CYII=" alt="Expand/collapse all" />

        </a>
      )
    }


    let accordionidhash = '#' + this.componentid + '-' + 'accordion'

    let expandbody = "accordion-collapse collapse"
    let expandheader = "accordion-button collapsed shadow-none"
    if (this.expandallclick) {
      expandbody = "accordion-collapse show"
      expandheader = "accordion-button shadow-none"
    }


    // const myData = this.items.sort((a: any, b: any) => a.ListItemAllFields.nypwebc_ItemOrder > b.ListItemAllFields.nypwebc_ItemOrder ? 1 : -1)
    let myData: any = {}
    if (this.sortversion === 1) {
      myData = this.items.sort((a: any, b: any) => a.ListItemAllFields.nypwebc_ItemOrder > b.ListItemAllFields.nypwebc_ItemOrder ? 1 : -1)
    }
    else if (this.subsection !== "all") {
      myData = this.items.sort((a: any, b: any) => a.ListItemAllFields.nypwebc_SubSubSection > b.ListItemAllFields.nypwebc_SubSubSection ? 1 : -1)
    }
    else {
      myData = this.items.sort((a: any, b: any) => a.ListItemAllFields.nypwebc_Section > b.ListItemAllFields.nypwebc_Section ? 1 : -1)
    }

    if (this.subsection !== "all") {
      let filtersubsection = this.subsection
      myData = _.filter(myData, function (n: any) {
        return n.ListItemAllFields.nypwebc_SubSection === filtersubsection;
      });
    }
    let campuses = [];

    if (this.sortversion === 2)
    {
    if (this.subsection !== "all") {

      campuses = _.uniq(_.map(myData, 'ListItemAllFields.nypwebc_SubSubSection')).sort()

    }
    else {
      campuses = _.uniq(_.map(myData, 'ListItemAllFields.nypwebc_Section')).sort()
    }
  }
  else {
    if (this.subsection !== "all") {

      campuses = _.uniq(_.map(myData, 'ListItemAllFields.nypwebc_SubSubSection'))

    }
    else {
      campuses = _.uniq(_.map(myData, 'ListItemAllFields.nypwebc_Section'))
    }
  }


    campuses.forEach((element: any, index) => {

      if (element) {
        let idheading = this.componentid + 'heading' + index
        let idcollapsehash = '#' + this.componentid + 'collapse' + index
        let idcollapse = this.componentid + 'collapse' + index
        const contentsHeaderArray = []
        contentsHeaderArray.push(
          <h2 class="accordion-header" id={idheading}>
            <button class={expandheader} style={{ fontSize: "16px" }} type="button" data-bs-toggle="collapse" data-bs-target={idcollapsehash} aria-expanded="false" aria-controls={idcollapse}>
              {element.substr(element.indexOf('.') + 1)}
            </button>
          </h2>
        )

        let campusItems = []

        if (this.subsection !== "all") {
          campusItems = _.filter(myData, function (n: any) {
            return n.ListItemAllFields.nypwebc_SubSubSection === element;
          });
        }
        else {
          campusItems = _.filter(myData, function (n: any) {
            return n.ListItemAllFields.nypwebc_Section === element;
          });
        }

        if (this.sortversion !== 1) {
          // campusItems= campusItems.sort((a: any, b: any) => a.Title > b.Title ? 1 : -1)

          campusItems = _.orderBy(campusItems, ['ListItemAllFields.Title'], ['asc']);

        }


        const listitems = []
        for (let i = 0; i < campusItems.length; i++) {

          let itemUrl = this.webpath + "/" + this.listname + "/" + campusItems[i].Name + "?Web=1"
          let title = ""
          if (campusItems[i].Title) {
            title = campusItems[i].Title
          }
          else {
            title = campusItems[i].Name
          }
          listitems.push(<li class="list-group-item"> <a href={itemUrl} target= "_blank"  data-interception="off" >{title}</a></li>)

        }

        contentsArray.push(
          <div class="accordion-item">
            {contentsHeaderArray}
            <div id={idcollapse} class={expandbody} aria-labelledby={idheading} data-bs-parent={accordionidhash} >
              <div class="accordion-body">
                <ul class="list-group list-group-flush" style={{ borderBottomRightRadius: "10px", borderBottomLeftRadius: "10px" }}>
                  {listitems}
                </ul>
              </div>
            </div>
          </div>
        )
      }
    })
    if (this.exptoggle) {
      contentsArray.unshift(expToggleArray)
    }
    return contentsArray

  }

  render() {


    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"


      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }


    let accordionid = this.componentid + '-' + 'accordion'
    return (

      this.isLoading ?
        <loader-component />
        :
        this.header && this.items.length > 0 ?

          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                <div class="accordion accordion-flush" id={accordionid}>
                  {this.getContents()}
                </div>
              </div>
            </div>
          </div>
          :

          <div class="row gx-0" style={parentstyle}  >
            <div style={style} >
              <div class="accordion accordion-flush" id={accordionid}>
                {this.getContents()}
              </div>
            </div>
          </div>
    )


  }
}
